(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let cancelPending = () => {};
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-kz-scroll]');
    if (!link) return;
    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    cancelPending();
    target.setAttribute('tabindex', '-1');
    target.focus({preventScroll:true});
    target.scrollIntoView({behavior:reduced() ? 'auto' : 'smooth', block:'start'});
    history.replaceState(null, '', link.getAttribute('href'));
    // Lazy media above a distant anchor can resize during smooth scrolling.
    // Re-align briefly after layout settles, never after manual navigation.
    let active = true;
    let settleTimer;
    const align = () => {
      if (active) target.scrollIntoView({behavior:'instant', block:'start'});
    };
    const schedule = () => {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(align, 160);
    };
    const observer = new ResizeObserver(schedule);
    const main = document.getElementById('MainContent');
    const firstTimer = setTimeout(() => {
      if (!active) return;
      align();
      if (main) observer.observe(main);
    }, reduced() ? 0 : 650);
    const stop = () => {
      active = false;
      clearTimeout(firstTimer);
      clearTimeout(settleTimer);
      observer.disconnect();
      ['wheel','touchstart','keydown','pointerdown'].forEach(type => window.removeEventListener(type, stop));
    };
    ['wheel','touchstart','keydown','pointerdown'].forEach(type => window.addEventListener(type, stop, {once:true,passive:true}));
    setTimeout(stop, 3000);
    cancelPending = stop;
  });
})();
